import React from 'react'
import { t } from '../../../utilities/translator';
import { REVIEW_SCORE_MULTIPLIER } from '../../../constants/constants';
import { getReviewWord } from '../../../utilities/helpers';

const TrustYouScore = ({
  trustYouReviews,
}) => {
  const { reviewScore, reviewCount } = trustYouReviews;
  const score = reviewScore * REVIEW_SCORE_MULTIPLIER;
  const reviewWord = getReviewWord(reviewScore);

  if (!score && !reviewWord && !reviewCount) return null;

  return (
    <div className="flex gap-2 items-center hotel-score">
      {score ? (
        // TODO: Fix bg-brand-700 to azure-700
        <div className="js-review-score h-7 w-7 rounded bg-brand-700 flex items-center justify-center label-small font-semibold text-white">
          {score}
        </div>
      ) : null}
      {reviewWord && reviewCount ? (
        <div className="flex gap-1 text-[11px] font-medium">
          <span className="text-primary">{reviewWord}</span>
          <span className="text-secondary">{reviewCount} {t('dealItem.reviews')}</span>
        </div>
      ) : null}
    </div>
  )
}

export default TrustYouScore
